import React, {useEffect, useState} from 'react';
import {Col, Container, Row} from 'react-bootstrap';
import {service as FileUploadService} from "../../../Services/FileUploadService";
import {Glyphicon} from "../../Common/GlyphIcon";
import {useCheckAuth} from "../../../Hooks/RouteHooks";
import {useClassNames} from "../../../Hooks/StyleHooks";


import {StreamBankPageHeader} from "../../Common/StreamBankPageHeader";


export const SecureDownloadPage = props => {
    useCheckAuth();

    const classNames = useClassNames('sb-secure-download-page');

    const [fileName, setFileName] = useState('Starting Download');
    const [message, setMessage] = useState('Your download will begin shortly.');

    useEffect(() => {
        loadData();
    }, []);

    const loadData = () => {
        const params = props?.match?.params;

        if(params?.fileId) {
            FileUploadService.DownloadFile(params?.fileName || "unknownFile", params?.fileId)
                .then(fileUploadObject => {
                    console.log(fileUploadObject);
                    setFileName(fileUploadObject.name);
                    setMessage('Your download will begin shortly.');
                })
                .catch(
                    x => {
                        setFileName((x?.xhr?.status === 404 ? "File Not Found" : "Error"));
                        setMessage(x.message);
                    }
                );
        } else {
            setFileName('Error');
            setMessage('A valid file identifier was not included in the URL. Please check that you have copied the link correctly.');
        }
    };


    const title = "Secure Download Page";

    return <Container className={classNames}>
        <StreamBankPageHeader
            Title={title}
        />
        <Row>
            <Col xs={12} md={12}><h2>{title}</h2></Col>
        </Row>
        <div className="download-container">
            <Row>
                <Col xs={3} className="">
                    <div className="sb-filedownload-left-side-border download-image">
                        <Glyphicon glyph="cloud-download" />
                    </div>
                </Col>
                <Col xs={9}>
                    <div className="sb-filedownload-right-side-border">
                        <Row>
                            <Col xs={12}>
                                <h3>{fileName ?? ""}</h3>
                            </Col>
                        </Row>
                        {message ?? ""}
                    </div>
                </Col>
            </Row>
        </div>
    </Container>;
};


